import Example from '$s/Example.svelte';

const app = new Example({
  target: document.body,
});

export default app;
